import { useState, useEffect } from 'react';

export function useSvgFromUrl(url: string | undefined, className?: string) {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    if (url) {
      fetch(url)
        .then(response => response.text())
        .then(svgText => {
          let cleanedSvg = svgText
            .replace(/width="[^"]*"/g, '')
            .replace(/height="[^"]*"/g, '');
          
          if (className) {
            cleanedSvg = cleanedSvg.replace(/<svg/, `<svg className="${className}"`);
          }
          
          setSvgContent(cleanedSvg);
        })
        .catch(err => console.error('Failed to fetch SVG:', err));
    } else {
      setSvgContent(null);
    }
  }, [url, className]);

  return svgContent;
}